import { Component, input, output } from '@angular/core';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  CrntButton,
  CrntIcon,
  CrntRadioGroup,
  CrntRadio,
  CrntFormControlLabel,
  CrntFormControlHelpText,
  CrntFormControlValidationMessage,
} from '@essent/current-web-angular';

import type {
  SingleAnswerQuestion,
  SingleAnswerQuestionOption,
} from '../models/single-answer-question.interface';
import type { QuestionnaireInfoModalTarget } from '../models/questionnaire-target.interface';
import { ProgressBarComponent } from '../progress-bar/progress-bar.component';
import { djb2Hash } from '../util/djb2';

@Component({
  selector: 'wl-questionnaire-question-single',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    AutomationIdDirective,
    FontAwesomeModule,
    ProgressBarComponent,
    CrntButton,
    CrntIcon,
    CrntRadioGroup,
    CrntRadio,
    CrntFormControlLabel,
    CrntFormControlHelpText,
    CrntFormControlValidationMessage,
  ],
  templateUrl: './questionnaire-question-single.component.html',
  styleUrls: [
    './questionnaire-question-single.component.ed.scss',
    './questionnaire-question-single.component.essent.scss',
  ],
})
export class QuestionnaireQuestionSingleComponent {
  readonly questionData = input.required<SingleAnswerQuestion>();
  readonly showPrevious = input(false);

  requestInfo = output<QuestionnaireInfoModalTarget>();
  submitAnswer = output<SingleAnswerQuestionOption>();
  back = output<void>();

  formData = new FormGroup({
    chosenAnswer: new FormControl<SingleAnswerQuestionOption | null>(
      null,
      Validators.required
    ),
  });

  get chosenAnswer() {
    return this.formData.controls.chosenAnswer;
  }

  readonly rendering = {
    nextQuestion: 'Volgende vraag',
    previousLabel: 'Vorige vraag',
    invalidMessage: 'U heeft nog geen antwoord geselecteerd',
  };

  onSubmit() {
    this.formData.markAllAsTouched();
    if (this.formData.valid && this.chosenAnswer.value) {
      this.submitAnswer.emit(this.chosenAnswer.value);
    }
  }

  optionToId(option: SingleAnswerQuestionOption): string {
    return djb2Hash(option.label);
  }
}
